import { GET_DELIVERY_BOY_LIST } from "./types"
import axios from "axios"

export const getDeliveryBoyList = async (dispatch, token) => {
  try {
    const res = await axios.get(
      `/vendorapis/delivery_boy/delivery/listDeliveryAgents?token=${token}`
    )
    return dispatch({
      type: GET_DELIVERY_BOY_LIST,
      payload: res && res.data && res.data.results ? res.data.results : "",
    })
  } catch (error) {
    console.log("error catched")
  }
}
